export default [
  {
    path: '/operations',
    name: 'Operations',
    component: () => import('@/layout'),
    redirect: '/operations/divide-config',
    meta: {
      title: '运营管理',
    },
    children: [
      {
        path: 'divide-config',
        name: 'divideConfig',
        component: () => import('@/views/web/operations/divide-config'),
        meta: {
          title: '手工清分操作',
          noCache: false,
          auth: true,
          trackCode: 'menu-14',
          trackName: '运营管理 - 手工清分操作',
          activeMenu: '/operations/divide-config',
        },
      },
    ],
  },
];
